/* eslint-disable react/no-danger */
import { Icon } from '@elipssolution/harfang';
import { mdiAlert } from '@mdi/js';
import { styled } from '@mui/material';
import sanitizeHtml from 'sanitize-html';

import { AlertBannerProps } from '../../types/alert';
import Banner from '../Banner';

const AlertBannerContainer = styled(Banner)(({ theme: { palette } }) => ({
	backgroundColor: palette.error.main,
	color: palette.getContrastText(palette.error.main),

	'& > svg': {
		minWidth: 24,
	},
}));

const DesktopAlertBanner = ({ content, sanitizeOptions }: AlertBannerProps) => (
	<AlertBannerContainer>
		<Icon path={mdiAlert} size="medium" />

		<div
			dangerouslySetInnerHTML={{
				__html: sanitizeHtml(content, sanitizeOptions),
			}}
		/>
	</AlertBannerContainer>
);

export default DesktopAlertBanner;
